/**
 * Icon registry resolver
 *
 * Resolves compiled product icons by name. Tenant-specific artwork is no longer compiled: it
 * comes from runtime configuration and is looked up by `tenantIcon` in `aos-ui-universal`
 * before this resolver is consulted, so call sites read
 * `tenantIcon(name) ?? compiledIcon(name)`.
 */

import type { IconName, IconRegistry } from '../types'
import { baseIcons } from './base'

/**
 * Resolve a compiled icon by name.
 *
 * @param name - Icon name to resolve
 * @returns The resolved icon import, or undefined if there is no compiled glyph for that name
 */
export function compiledIcon(name: IconName): Svg | undefined {
    return (baseIcons as IconRegistry)[name]
}

/**
 * Get every compiled icon.
 */
export function getIconRegistry(): Record<string, Svg> {
    return { ...baseIcons }
}

/**
 * Check whether a compiled icon exists for a name.
 */
export function hasIcon(name: IconName): boolean {
    return compiledIcon(name) !== undefined
}
